import { useParams, useLocation } from 'react-router-dom';
import ScheduleCard from '../ScheduleComponent/ScheduleCard.jsx';
import { ScheduleData } from '../../hook/ScheduleData.js';

function GroupScheduleDetail() 
{
  const { groupName } = useParams();
  const location = useLocation();
  
  const vo = location.state?.item?.vo ?? null;

  const { data: scheduleData, loading, error } = ScheduleData('/Groups', groupName, vo);

  if (loading) return <div className='loading'>Загрузка расписания...</div>;
  if (error)   return <div className='error'>Ошибка: {error}</div>;
  
  return <ScheduleCard scheduleData={scheduleData} />;
}

export default GroupScheduleDetail;